export const LEARN_MORE_URL =
  'https://help.postscript.io/en/articles/15184114-understanding-ai-eligibility-and-ai-bifurcation';
